import { get } from './httpClient'

export const getComments = (query) => get('/comment', query)
